module.exports = __webpack_public_path__ + "img/pin-lider-pro.1f190d9d.png";